import { useLingui } from '@lingui/react/macro';
import type { WidgetPage } from '../../types';
import { ModeBlock } from '../components/mode-block';
import { Page } from '../components/page';
import { ScoreBlock } from '../components/score-block';

export function Main({ onCloseRequest }: WidgetPage) {
  const { t } = useLingui();

  return (
    <Page title={t`Accessibility Assistant`} onCloseRequest={onCloseRequest}>
      <ModeBlock />
      <ScoreBlock />
    </Page>
  );
}
